import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RequestService } from 'src/app/services/request.service';
import { ModalDialog } from 'src/app/Modal/modal';
import { GetCompanyIdBasedOnRole } from 'src/app/helper/GetCompanyIdBasedOnRole';
import { AuthService } from 'src/app/services/auth.service';
import { dynamicLocaleCompareWithOptions } from 'src/app/helper/sortFunctions';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.css'],

})
export class CompanyListComponent implements OnInit, OnDestroy {
  // Properties
  displayedColumns: string[];
  dataSource = new MatTableDataSource;
  private destroyed$: Subject<void> = new Subject();
  company = {
    title: 'Company list', addButton: 'Add new company',
    col1Titel: 'Company name', col2Titel: 'Country', col3Titel: 'Contact', col4Titel: 'Active state', col5Titel: 'Actions',
    action1: 'Edit company', action2: 'Delete company', action3: 'Set company inactive', action4: 'Set company active',
    deleteDialog: 'Do you really want to delete this company?'
  }

  // Ctor
  constructor(private route: ActivatedRoute, private router: Router, private dialog: MatDialog, private requestService: RequestService, private authService: AuthService) { }

  // Lifecycle Hooks
  ngOnInit() {
    this.displayedColumns = ['companyName', 'country', 'contactName', 'activeState', 'companyActions'];
    this.loadCompanies();
  }

  // Methods
  openCellEdit(companyId: number): void {
    this.router.navigate(['../', 'edit', companyId], { relativeTo: this.route });
  }

  showDeleteDialog(companyId: number): void {
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: this.company.deleteDialog,
        showCancel: true,
        cancelButtonText: 'Cancel',
        saveButtonText: 'Okay'
      }
    });

    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.deleteCompany(companyId);
        } else {
          // do nothing just close the modal
        }
      });
  }

  deleteCompany(companyId: number): void {
    this.requestService.deleteCompany(companyId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(next => {
        this.loadCompanies();
      });
  }

  activateCompany(id: number) {
    this.requestService.activateCompany(id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(next => {
        this.loadCompanies();
      });
  }

  deactivateCompany(id: number) {
    this.requestService.deactivateCompany(id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(next => {
        this.loadCompanies();
      });
  }

  loadCompanies() {
    this.requestService.getActiveCompaniesWithoutSystemCompanyForCompanyListView()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(next => {
        if (next) {
          this.dataSource.data = next.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));;
        }
        else {
          this.dataSource.data = [];
        }
      });
  }

  getIsActiveText(isActive: boolean): string {
    if (isActive) {
      return "Active";
    }
    else {
      return "Not active";
    }
  }
  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}